require("@cirrus/legacy/vendor-bower/bootstrap/less/bootstrap.less")
require("@cirrus/legacy/less/eas-external-login.less")
require("@cirrus-delivery/v1/_less/eas-delivery-theme.less")
require("@cirrus/assets/font-opensans/css/style.css")
require("./anonymous-login.es6")
